import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("carnier_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-vegetal-800 px-5">
      <Seo title="Espace admin — Carnier Toiture et Habitat" />
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-2xl bg-white shadow-xl p-8">
        <div className="mx-auto grid place-items-center h-12 w-12 rounded-lg bg-terracotta-500 text-white font-heading font-extrabold text-xl">C</div>
        <h1 className="mt-5 text-center font-heading text-2xl font-bold text-neutral-900">Espace administrateur</h1>
        <p className="mt-1 text-center text-sm text-neutral-500">Consultez les demandes reçues</p>

        {error && <p data-testid="admin-login-error" className="mt-4 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{error}</p>}

        <div className="mt-6 space-y-4">
          <div>
            <Label className="text-sm">Email</Label>
            <Input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label className="text-sm">Mot de passe</Label>
            <Input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-terracotta-500 text-white hover:bg-terracotta-600 transition-colors font-medium disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Se connecter
          </button>
        </div>
      </form>
    </div>
  );
}
